import { render, staticRenderFns } from "./ArchNotifications.vue?vue&type=template&id=d172ac90"
import script from "./ArchNotifications.vue?vue&type=script&lang=ts"
export * from "./ArchNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-2064ba0760/5/root/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../.yarn/__virtual__/vuetify-loader-virtual-36d94f05a9/5/root/.yarn/berry/cache/vuetify-loader-npm-1.7.2-d296a16f38-10c0.zip/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
